<div>
	<div class="row time-sheet-actions">
		<mat-error fxFlex *ngIf="timeSheetData?.error">{{ timeSheetData.error }}</mat-error>
		<div
			*ngIf="
				timeSheetData && timeSheetData.timeSheet && timeSheetData.timeSheet.status !== timeSheetStatusEnum.Paid;
				else paid
			"
			fxLayoutGap="5px"
		>
			<button (click)="openDiemDialog()" mat-raised-button color="primary">
				<i class="fa fa-plus" aria-hidden="true"></i> Per Diem
			</button>
			<button (click)="openTripDialog()" mat-raised-button color="primary" *ngIf="loggedInUserDetails.isAdmin">
				<i class="fa fa-plus" aria-hidden="true"></i> Trip
			</button>
			<button (click)="openTransactionDialog()" mat-raised-button color="primary">
				<i class="fa fa-plus" aria-hidden="true"></i> Transaction
			</button>
		</div>
		<ng-template #paid>
			<div *ngIf="!timeSheetData?.error">
				<mat-card-title fxLayout="row" fxLayoutAlign="start center">
					<h5 class="readonly-label">Historic Time Sheet</h5>
				</mat-card-title>
			</div>
		</ng-template>
		<div class="right-btns-group">
			<button
				*ngIf="timeSheetData && timeSheetData.timeSheet"
				class="mr-xs"
				mat-raised-button
				[disabled]="disabledSubmitBtn"
				[disableRipple]="disabledSubmitBtn"
				[ngClass]="[
					loggedInUserDetails.isAdmin &&
					timeSheetData.timeSheet.status === timeSheetStatusEnum.ApprovedByAdmin
						? 'unapprove'
						: '',
					loggedInUserDetails.isAdmin &&
					timeSheetData.timeSheet.status !== timeSheetStatusEnum.ApprovedByAdmin
						? 'approve'
						: '',
					!loggedInUserDetails.isAdmin ? 'submitTimeSheet' + timeSheetData.timeSheet.status : '',
					disabledSubmitBtn ? 'disabledSubmitBtn' : ''
				]"
				(click)="submitTimeSheet()"
			>
				<span *ngIf="!loggedInUserDetails.isAdmin; else isAdmin">
					{{ timeSheetStatusButtonsEnum[timeSheetStatusEnum[timeSheetData.timeSheet.status]] }}
				</span>
				<ng-template #isAdmin>
					<span
						*ngIf="
							timeSheetData.timeSheet.status === timeSheetStatusEnum.NotStarted ||
							timeSheetData.timeSheet.status === timeSheetStatusEnum.InProgress ||
							timeSheetData.timeSheet.status === timeSheetStatusEnum.SubmittedByEmployee
						"
					>
						Approve
					</span>
					<span *ngIf="timeSheetData.timeSheet.status === timeSheetStatusEnum.ApprovedByAdmin">
						Unapprove
					</span>
					<span *ngIf="timeSheetData.timeSheet.status === timeSheetStatusEnum.Paid">
						Paid
					</span>
				</ng-template>
			</button>
			<mat-form-field *ngIf="timeSheets.length > 0">
				<mat-select [(value)]="selectedDate">
					<mat-option
						*ngFor="let t of timeSheets"
						(click)="monthSelectedHandler(t.startDate)"
						[value]="t.startDate"
					>
						{{ t?.startDate | date: 'MMMM y' }}
						<span *ngIf="t?.startDate == currentDate">(Current)</span>
						<span *ngIf="t?.startDate == previousDate">(Previous)</span>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
</div>

<mat-drawer-container
	*ngIf="timeSheetData && timeSheetData.timeSheet"
	class="play-web-timesheets"
	autosize
	[ngClass]="{ fixed: showTotal && isMobile }"
	(backdropClick)="onTotalToggle()"
>
	<mat-drawer
		#drawer
		[ngStyle]="!isMobile && { right: '30px' }"
		[mode]="isMobile ? 'over' : 'side'"
		position="end"
		[opened]="showTotal"
		class="sticky"
		id="sticky"
	>
		<div class="column total-width">
			<button *ngIf="showTotal" (click)="onTotalToggle()" class="caret-right" mat-mini-fab>
				<mat-icon>chevron_right</mat-icon>
			</button>
			<!--   User Details Card     -->
			<mat-card *ngIf="timeSheetData && timeSheetData.currentEmployee" class="user-card">
				<div class="pl-1 pr-1 profile-i">
					<div class="profile-row user-name readonly-label">
						<h3>
							{{
								timeSheetData.currentEmployee?.firstName + ' ' + timeSheetData.currentEmployee?.lastName
							}}
						</h3>
					</div>
					<div class="profile-row margin-top-20">
						<mat-icon class="user-icon">account_circle</mat-icon>
						<div class="profile-column no-margin-tb">
							<div class="profile-row">
								<div class="profile-column">
									<div class="profile-row font-weight-bold">
										<span *ngIf="!timeSheetData.currentEmployee.overrideJobTitleId">{{
											timeSheetData.currentEmployee.jobTitleName
										}}</span>
										<span *ngIf="timeSheetData.currentEmployee.overrideJobTitleId">{{
											timeSheetData.currentEmployee.overrideJobTitleName
										}}</span>
									</div>
									<div class="profile-row readonly-label text-df">Title</div>
								</div>
								<div class="profile-column">
									<div class="profile-row font-weight-bold">
										{{ timeSheetData.currentEmployee?.hireDate | date }}
									</div>
									<div class="profile-row readonly-label text-df">Hired</div>
								</div>
								<div class="profile-column">
									<div class="profile-row font-weight-bold">
										{{ timeSheetData.currentEmployee?.payrollNumber }}
									</div>
									<div class="profile-row readonly-label text-df">Payroll</div>
								</div>
							</div>
							<div class="profile-row">
								<div class="profile-column">
									<div class="profile-row font-weight-bold">
										<span *ngIf="!timeSheetData.currentEmployee.overrideAircraftModelId">{{
											timeSheetData.currentEmployee.aircraftModelName
										}}</span>
										<span *ngIf="timeSheetData.currentEmployee.overrideJobTitleId">{{
											timeSheetData.currentEmployee.overrideAircraftModelName
										}}</span>
									</div>
									<div class="profile-row readonly-label text-df">Aircraft Model</div>
								</div>
								<div class="profile-column">
									<div class="profile-row font-weight-bold">
										{{ timeSheetData.currentEmployee?.payScale?.yearsOfService }}
									</div>
									<div
										*ngIf="timeSheetData.currentEmployee?.payScale?.yearsOfService == 1"
										class="profile-row readonly-label text-df"
									>
										Year of Service
									</div>
									<div
										*ngIf="timeSheetData.currentEmployee?.payScale?.yearsOfService != 1"
										class="profile-row readonly-label text-df"
									>
										Years of Service
									</div>
								</div>
								<div class="profile-column">
									<div class="profile-row font-weight-bold">
										{{ timeSheetData.currentEmployee?.workdayNumber }}
									</div>
									<div class="profile-row readonly-label text-df">Workday</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</mat-card>
			<mat-card
				*ngIf="timeSheetData?.timeSheet?.totals"
				class="other-card"
				fxLayout="column"
				fxLayoutWrap
				fxLayoutGap="5px"
			>
				<app-recon-totals
					class="total-table-border"
					[title]="'Total Reconciliation'"
					[totals]="timeSheetData.timeSheet.totals.totalReconciliation"
					[totalOfTotals]="timeSheetData.timeSheet.totals.totalOfReconciliationTotals"
				></app-recon-totals>

				<app-hours-summary-totals
					class="total-table-border"
					*ngIf="timeSheetData.timeSheet.totals.hoursSummaryTotals.length > 0"
					[title]="'Hours Summary'"
					[firstColumnTitle]="'Credit/Activity'"
					[hoursTotals]="timeSheetData.timeSheet.totals.hoursSummaryTotals"
					[secondaryTotals]="timeSheetData.timeSheet.totals.daysSummaryTotals"
					[secondaryTotalsHeader]="'Days'"
					[totalOfHoursSummary]="timeSheetData.timeSheet.totals.totalOfHoursSummary"
				></app-hours-summary-totals>

				<app-hours-summary-totals
					class="total-table-border"
					*ngIf="timeSheetData.timeSheet.totals.instructionGivenTotals.length > 0"
					[title]="'Instruction Given Summary'"
					[firstColumnTitle]="'Instruction Given'"
					[hoursTotals]="timeSheetData.timeSheet.totals.instructionGivenTotals"
					[totalOfHoursSummary]="timeSheetData.timeSheet.totals.totalOfInstructionGivenTotals"
					[isTotalDollars]="true"
				></app-hours-summary-totals>

				<app-instruction-totals
					class="total-table-border"
					*ngIf="timeSheetData.timeSheet.totals.flatRateInstructionTotals.length > 0"
					[title]="'Flat Rate Instruction Summary'"
					[totals]="timeSheetData.timeSheet.totals.flatRateInstructionTotals"
					[totalOfTotals]="timeSheetData.timeSheet.totals.totalOfFlatRateInstructionTotals"
				></app-instruction-totals>

				<app-hours-summary-totals
					class="total-table-border"
					*ngIf="timeSheetData.timeSheet.totals.incentiveTotals.length > 0"
					[title]="'Incentives Summary'"
					[firstColumnTitle]="'Incentives'"
					[dollarTotals]="timeSheetData.timeSheet.totals.incentiveTotals"
					[totalOfHoursSummary]="timeSheetData.timeSheet.totals.totalOfIncentiveTotals"
					[isTotalDollars]="true"
				></app-hours-summary-totals>

				<app-recon-totals
					class="total-table-border"
					[title]="'Variable Pay'"
					[totals]="timeSheetData.timeSheet.totals.variablePayTotals"
					[totalOfTotals]="timeSheetData.timeSheet.totals.totalOfPayVariablesTotals"
				>
				</app-recon-totals>
			</mat-card>
		</div>
	</mat-drawer>
	<div fxFlexFill>
		<div class="column no-padding-left">
			<button *ngIf="!showTotal" mat-mini-fab (click)="onTotalToggle()" class="caret-left">
				<mat-icon>chevron_left</mat-icon>
			</button>

			<mat-list
				*ngIf="
					perDiemsWithErrors.length ||
					tripsWithErrors.length ||
					tripsWithNoPerDiems.length ||
					isTimeSheetLocked ||
					(timeSheetData && timeSheetData.timeSheet)
				"
				class="pt-0"
			>
				<mat-list-item
					*ngIf="
						timeSheetData.timeSheet.status == timeSheetStatusEnum.SubmittedByEmployee && !isTimeSheetLocked
					"
					class="waitingApproval"
				>
					<mat-icon class="card-access_time-icon" mat-list-icon>send</mat-icon>
					<h4 mat-line>
						Submitted for approval
					</h4>
					<mat-icon class="mat-text-muted small">warning</mat-icon>
				</mat-list-item>
				<mat-list-item *ngIf="isTimeSheetLocked" class="card-list-access_time-item">
					<mat-icon class="card-access_time-icon" mat-list-icon>lock</mat-icon>
					<h4 mat-line>
						{{ timeSheetLockOutError }}
					</h4>
					<mat-icon class="mat-text-muted small">error_outline</mat-icon>
				</mat-list-item>
				<mat-list-item *ngIf="perDiemsWithErrors.length" class="card-list-access_time-item">
					<mat-icon class="card-access_time-icon" mat-list-icon>calendar_today</mat-icon>
					<h4 mat-line *ngIf="perDiemsWithErrors.length > 1">
						{{ perDiemsWithErrors.length }} Per diems have advisories
					</h4>
					<h4 mat-line *ngIf="perDiemsWithErrors.length == 1">
						{{ perDiemsWithErrors.length }} Per diem has advisories
					</h4>
					<mat-icon class="mat-text-muted small">error_outline</mat-icon>
				</mat-list-item>
				<mat-list-item *ngIf="tripsWithErrors.length" class="card-list-access_time-item">
					<mat-icon class="card-access_time-icon" mat-list-icon>airplanemode_active</mat-icon>
					<h4 mat-line *ngIf="tripsWithErrors.length > 1">
						{{ tripsWithErrors.length }} Trips missing comments
					</h4>
					<h4 mat-line *ngIf="tripsWithErrors.length == 1">
						{{ tripsWithErrors.length }} Trip missing comments
					</h4>
					<mat-icon class="mat-text-muted small">error_outline</mat-icon>
				</mat-list-item>
				<mat-list-item *ngIf="tripsWithNoPerDiems.length" class="card-list-access_time-item">
					<mat-icon class="card-access_time-icon" mat-list-icon>assignment_late</mat-icon>
					<h4 mat-line *ngIf="tripsWithNoPerDiems.length > 1">
						{{ tripsWithNoPerDiems.length }} Trips with no per diem
					</h4>
					<h4 mat-line *ngIf="tripsWithNoPerDiems.length == 1">
						{{ tripsWithNoPerDiems.length }} Trip with no per diem
					</h4>
					<mat-icon class="mat-text-muted small">error_outline</mat-icon>
				</mat-list-item>
			</mat-list>
			<mat-card
				class="no-padding-left no-margin"
				*ngIf="timeSheetData && (timeSheetData.tripsAndPerDiems || timeSheetData.transactions)"
				fxLayout="column"
			>
				<mat-card-title>
					<h5 class="mt-0">Reconciliation</h5>
				</mat-card-title>

				<ng-container *ngFor="let item of timeSheetData.tripsAndPerDiems">
					<!-- Per Diems Cards        -->
					<mat-card
						class="trip-card table-card total-table-border"
						[ngClass]="[item.perDiem && item.perDiem.errors.length > 0 ? 'left-border-warning' : '']"
					>
						<mat-card-title *ngIf="item.perDiem">
							<mat-list class="trip-card-header">
								<mat-list-item>
									<div fxLayout="column" fxFlex fxLayoutAlign="center">
										<div fxLayout="row" fxLayoutAlign="space-between center">
											<span class="per-diem-wrap">
												Per Diem
												{{ item.perDiem.perDiemStart | date: 'MM/dd/yyyy, hh:mm a' }} -
												{{ item.perDiem.perDiemEnd | date: 'MM/dd/yyyy, hh:mm a' }} (
												{{ calculateTimeDifference(item.perDiem) | hoursMinutes }} )
												&nbsp;&nbsp;
											</span>
											<span class="readonly-label">{{ item.perDiem.comments }}</span>
											<button mat-mini-fab color="primary" (click)="openDiemDialog(item.perDiem)">
												<mat-icon *ngIf="hasError; else edit">
													preview
												</mat-icon>
												<ng-template #edit>
													<mat-icon>edit</mat-icon>
												</ng-template>
											</button>
										</div>
										<ng-container *ngIf="item.perDiem.errors.length > 0">
											<div fxLayout="row" fxLayoutAlign="flex-start center" class="perDiemError">
												<mat-error
													*ngFor="let error of item.perDiem.errors | unique"
													class="perDiem-warning"
												>
													{{ error }}
												</mat-error>
											</div>
										</ng-container>
									</div>
								</mat-list-item>
							</mat-list>
						</mat-card-title>
						<div
							*ngIf="item.trips && item.trips.length"
							class="trip-table"
							[ngClass]="[!item.perDiem ? 'left-border-warning' : '']"
						>
							<mat-card-title *ngIf="!item.perDiem">
								<mat-list class="trip-card-header">
									<mat-list-item fxLayout="column" fxLayoutAlign="center">
										<span>Trips</span> &nbsp;&nbsp; <mat-error> (no per diem)</mat-error>
									</mat-list-item>
								</mat-list>
							</mat-card-title>
							<table mat-table [dataSource]="item.trips" multiTemplateDataRows>
								<ng-container matColumnDef="tripStart">
									<th mat-header-cell *matHeaderCellDef>Block Out</th>
									<td
										mat-cell
										*matCellDef="let element"
										[ngClass]="[
											item.perDiem && !item.perDiem.errors.length && element.commentNeededError
												? 'left-border-warning'
												: ''
										]"
									>
										{{ element.tripStart | date: 'shortDate' }}
									</td>
								</ng-container>

								<ng-container matColumnDef="routeInformation">
									<th mat-header-cell *matHeaderCellDef>Route</th>
									<td mat-cell *matCellDef="let element">{{ element.routeInformation }}</td>
								</ng-container>

								<ng-container matColumnDef="tripNumber">
									<th mat-header-cell *matHeaderCellDef>Trip</th>
									<td mat-cell *matCellDef="let element">{{ element.tripNumber }}</td>
								</ng-container>

								<ng-container matColumnDef="tripStatus">
									<th mat-header-cell *matHeaderCellDef>Trip Status</th>
									<td mat-cell *matCellDef="let element">
										<mat-icon
											*ngIf="element.brokenTripCount"
											matTooltip="{{ 'Broken: ' + element.brokenTripCount + ' trips' }}"
											>broken_image</mat-icon
										>
										<mat-icon *ngIf="element.isBypassed" matTooltip="Bypassed"
											>sync_problem</mat-icon
										>
										<mat-icon *ngIf="element.isCanceled" matTooltip="Canceled"
											>airplanemode_inactive</mat-icon
										>
									</td>
								</ng-container>

								<ng-container matColumnDef="flightHours">
									<th mat-header-cell *matHeaderCellDef>Block Time</th>
									<td mat-cell *matCellDef="let element">
										{{ convertTimeToHours(element.flightMinutes) }}
									</td>
								</ng-container>

								<ng-container matColumnDef="loadsUnloadsCount">
									<th mat-header-cell *matHeaderCellDef>Load/Unloads</th>
									<td mat-cell *matCellDef="let element">{{ element.loadsUnloadsCount }}</td>
								</ng-container>

								<ng-container *ngIf="loggedInUserDetails.isAdmin" matColumnDef="tripVariesFromCmsData">
									<th mat-header-cell *matHeaderCellDef>Variance Approved</th>
									<td mat-cell *matCellDef="let element">
										<ng-container *ngIf="element.tripVariesFromCmsData">
											<mat-checkbox
												[disabled]="
													timeSheetData.timeSheet.status === timeSheetStatusEnum.Paid ||
													timeSheetData.timeSheet.status ===
														timeSheetStatusEnum.ApprovedByAdmin
												"
												(ngModelChange)="toggleTripVarianceApproval($event, element)"
												[(ngModel)]="element.varianceIsApproved"
											></mat-checkbox>
										</ng-container>
									</td>
								</ng-container>

								<ng-container matColumnDef="edit">
									<th mat-header-cell *matHeaderCellDef></th>
									<td mat-cell *matCellDef="let element" class="hover-icon">
										<mat-icon *ngIf="element?.commentNeededError" class="mr-1 warning">
											<span>warning</span>
										</mat-icon>
										<mat-icon class="grey" (click)="openTripDialog(element)">
											<span *ngIf="hasError || !loggedInUserDetails.isAdmin; else edit">
												preview
											</span>
											<ng-template #edit>
												<span *ngIf="loggedInUserDetails.isAdmin">edit</span>
											</ng-template>
										</mat-icon>
									</td>
								</ng-container>
								<ng-container matColumnDef="history">
									<th mat-header-cell *matHeaderCellDef></th>
									<td mat-cell *matCellDef="let element" class="hover-icon width-25">
										<mat-icon class="grey pull-right" (click)="openTimeSheetHistoryDialog(element)">
											<span>history</span>
										</mat-icon>
									</td>
								</ng-container>

								<ng-container matColumnDef="comments">
									<td mat-cell *matCellDef="let element" [attr.colspan]="displayedTripColumns.length">
										{{ element.comments }}
									</td>
								</ng-container>

								<tr class="trip-header" mat-header-row *matHeaderRowDef="displayedTripColumns"></tr>
								<tr
									mat-row
									*matRowDef="let row; columns: displayedTripColumns"
									[ngClass]="{
										'trip-variance--approved':
											row.tripVariesFromCmsData &&
											row.varianceIsApproved &&
											loggedInUserDetails.isAdmin,
										'trip-variance--unapproved':
											row.tripVariesFromCmsData &&
											!row.varianceIsApproved &&
											loggedInUserDetails.isAdmin
									}"
								></tr>
								<tr
									mat-row
									*matRowDef="let row; columns: ['comments']"
									class="comment-row"
									[ngClass]="{
										'trip-variance--approved':
											row.tripVariesFromCmsData &&
											row.varianceIsApproved &&
											loggedInUserDetails.isAdmin,
										'trip-variance--unapproved':
											row.tripVariesFromCmsData &&
											!row.varianceIsApproved &&
											loggedInUserDetails.isAdmin
									}"
								></tr>
							</table>
						</div>
					</mat-card>
				</ng-container>

				<!-- Transactions Cards       -->
				<ng-container *ngIf="timeSheetData?.transactions && timeSheetData.transactions.length">
					<mat-card class="trip-card table-card total-table-border">
						<mat-card-title>
							<mat-list class="trip-card-header trip-card-header-secondary">
								<mat-list-item>
									<h5 class="mt-1">Transactions</h5>
									<span fxFlex></span>
									<button
										*ngIf="timeSheetData.timeSheet.status !== timeSheetStatusEnum.Paid"
										mat-mini-fab
										color="primary"
										(click)="openTransactionDialog()"
									>
										<mat-icon *ngIf="hasError; else add">preview</mat-icon>
										<ng-template #add>
											<mat-icon>add</mat-icon>
										</ng-template>
									</button>
								</mat-list-item>
							</mat-list>
						</mat-card-title>
						<!-- transactions -->
						<div class="trip-table">
							<table mat-table [dataSource]="timeSheetData.transactions" multiTemplateDataRows>
								<ng-container matColumnDef="date">
									<th mat-header-cell *matHeaderCellDef>Date</th>
									<td mat-cell *matCellDef="let element">
										{{ element.transactionDate | date: 'shortDate' }}
									</td>
								</ng-container>
								<ng-container matColumnDef="value">
									<th mat-header-cell *matHeaderCellDef>Value</th>
									<td mat-cell *matCellDef="let element; let i = dataIndex">
										<span *ngIf="element.payCategory?.unit == 'Count'">{{ element.value }}</span>
										<span *ngIf="element.payCategory?.unit == 'Dollars'">{{
											element.value | currency
										}}</span>
										<span *ngIf="element.payCategory?.unit == 'Days'"
											>{{ element.value }}
											<small *ngIf="element.value === 1" class="mat-caption hint">day</small
											><small *ngIf="element.value > 1" class="mat-caption hint"
												>days</small
											></span
										>
										<span *ngIf="element.payCategory?.unit == 'Hours'"
											>{{ element.value | hoursMinutes }}
										</span>
									</td>
								</ng-container>
								<ng-container matColumnDef="category">
									<th mat-header-cell *matHeaderCellDef>Category</th>
									<td mat-cell *matCellDef="let element">{{ element.payCategory?.name }}</td>
								</ng-container>
								<ng-container matColumnDef="icon">
									<th mat-header-cell *matHeaderCellDef>Icon</th>
									<td mat-cell *matCellDef="let element">
										<i
											[style.background]="element.payCategory?.colorName"
											class="fa-1-5x fa {{ element.payCategory?.iconName }}"
										></i>
									</td>
								</ng-container>
								<ng-container matColumnDef="notes">
									<th mat-header-cell *matHeaderCellDef>Notes</th>
									<td mat-cell *matCellDef="let element; let i = dataIndex">
										<ng-container
											*ngFor="let note of element.timeSheetTransactionNoteValues; let x = index"
										>
											<p *ngIf="note.value" class="no-margin-tb">
												<span class="mat-caption hint"
													>{{ (element.payCategory?.notes)[x]?.name }}:</span
												>
												{{ note.value }}
											</p>
										</ng-container>
									</td>
								</ng-container>
								<ng-container matColumnDef="edit">
									<th mat-header-cell *matHeaderCellDef></th>
									<td mat-cell *matCellDef="let element" class="hover-icon">
										<mat-icon class="grey pull-right" (click)="openTransactionDialog(element)">
											<span *ngIf="hasError; else edit">
												preview
											</span>
											<ng-template #edit>
												<span>edit</span>
											</ng-template>
										</mat-icon>
									</td>
								</ng-container>
								<ng-container matColumnDef="history">
									<th mat-header-cell *matHeaderCellDef></th>
									<td mat-cell *matCellDef="let element" class="hover-icon width-25">
										<mat-icon class="grey pull-right" (click)="openTimeSheetHistoryDialog(element)">
											<span>history</span>
										</mat-icon>
									</td>
								</ng-container>
								<!-- Secondary Transaction's comments -->
								<ng-container matColumnDef="comments">
									<td
										mat-cell
										[attr.colspan]="displayedTransactionColumns.length"
										*matCellDef="let element"
									>
										{{ element.comments }}
									</td>
								</ng-container>
								<tr
									class="trip-header"
									mat-header-row
									*matHeaderRowDef="displayedTransactionColumns"
								></tr>
								<tr mat-row *matRowDef="let row; columns: displayedTransactionColumns"></tr>
								<tr mat-row *matRowDef="let row; columns: ['comments']" class="comment-row"></tr>
							</table>
						</div>
					</mat-card>
				</ng-container>
			</mat-card>
		</div>
	</div>
</mat-drawer-container>
